import { render, staticRenderFns } from "./BusinessRenovationPage.vue?vue&type=template&id=e861fd9c&scoped=true&"
import script from "./BusinessRenovationPage.vue?vue&type=script&lang=js&"
export * from "./BusinessRenovationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e861fd9c",
  null
  
)

export default component.exports